export const SHORT_FORMAT = { 
  year: 'numeric', 
  month: 'short', 
  day: 'numeric' 
} as const;

export const LONG_FORMAT = { 
  weekday: 'short',
  year: 'numeric', 
  month: 'short', 
  day: 'numeric' 
} as const;

export const APPLICATION_TREATMENT_DATE_FORMAT = {
  weekday: 'short',
  month: '2-digit',
  year: 'numeric',
  day: '2-digit',
} as const;

export function toIsoDateOnly(date: string | number | Date | null | undefined): string | undefined {
  if (!date) {
    return undefined;
  }

  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) {
    return undefined;
  }

  return parsed.toISOString().split('T')[0];
}


export const formatLocalDate = (date: string, locale?: string) => new Date(`${date}T00:00:00`).toLocaleDateString(locale, SHORT_FORMAT);

export const isValidDate = (date: string): boolean => {
  const parsed = new Date(date);
  return !Number.isNaN(parsed.getTime());
}

export const getDateFormatted = (date: Date, locale?: string): string => date.toLocaleDateString(locale, SHORT_FORMAT);
